import { atom } from 'recoil';

import { TaxType } from '~/types/cart';

const taxType = atom<TaxType>({
  key: 'taxType',
  default: TaxType.PERSONAL,
});

export default taxType;
